import { cn } from '@/utils/cn'
import { HTMLAttributes } from 'react'
import { ProductNotificationInfoBefore } from './ui/product-notification-info-before'
import { ProductNotificationInfoNotified } from './ui/product-notification-info-notified'
import { ProductNotificationInfoReached } from './ui/product-notification-info-reached'
import { useNotificationInfo } from './use-notification-info'
import { ProductNotificationInfoPending } from './ui/product-notification-info-pending'
export interface ProductNotificationInfoProps {
  productId: string
}

export const ProductNotificationInfo = ({
  className,
  productId,
  ...props
}: ProductNotificationInfoProps & HTMLAttributes<HTMLDivElement>) => {
  const { data: notificationInfo, pending } = useNotificationInfo(productId)

  if (pending) {
    return <ProductNotificationInfoPending />
  }
  if (!notificationInfo) {
    return null
  }

  const { price, isReached, hasNotification, linkUrl, notificationPrice } =
    notificationInfo

  const renderNotification = () => {
    if (!hasNotification) {
      return (
        <ProductNotificationInfoBefore
          productId={productId}
          price={price.price}
          priceLowest={price.priceLowest}
        />
      )
    }

    if (isReached) {
      return (
        <ProductNotificationInfoReached
          link={linkUrl}
          notificationPrice={notificationPrice ?? 0}
        />
      )
    }

    return (
      <ProductNotificationInfoNotified
        currentPrice={price.price}
        highestPrice={price.priceHighest}
        notificationPrice={notificationPrice ?? 0}
      />
    )
  }

  return (
    <div className={cn(className, 'px-5')} {...props}>
      {renderNotification()}
    </div>
  )
}
